import { useEffect, useState } from 'react';
import axios from 'axios';
/**
 * React hook to fetch multiple flag values for a tenant based on a supplied list of flag key, scope pairs.
 */
export function useFeatureFlagValues(props) {
    var tenantId = props.tenantId, flags = props.flags, apiBaseUrl = props.apiBaseUrl, accessToken = props.accessToken;
    var _a = useState(flags), results = _a[0], setResults = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        var fetchResults = [];
        var promises = [];
        var authConfig = {
            headers: { Authorization: "Bearer " + accessToken },
        };
        flags.forEach(function (flag) {
            var scope = flag.scope || "Tenant";
            var path = (apiBaseUrl !== null && apiBaseUrl !== void 0 ? apiBaseUrl : '') + "/config/api/v1/tenants/" + tenantId + "/featureFlags/flags/" + flag.flagKey + "/scopes/" + scope;
            var result = { flagKey: flag.flagKey, scope: scope };
            promises.push(axios
                .get(path, authConfig)
                .then(function (response) {
                var _a;
                result.flagValue = (_a = response.data) === null || _a === void 0 ? void 0 : _a.value;
            })
                .catch(function (error) {
                result.error = error;
            })
                .finally(function () {
                fetchResults.push(result);
            }));
        });
        Promise.all(promises).finally(function () {
            setResults(fetchResults);
            setLoading(false);
        });
    }, [flags, apiBaseUrl, tenantId, accessToken]);
    return {
        flags: results,
        loading: loading,
    };
}
//# sourceMappingURL=use-feature-flag-values.js.map